import { render, staticRenderFns } from "./blank_only_logo.vue?vue&type=template&id=aeb416f2&scoped=true&lang=pug&"
import script from "./blank_only_logo.vue?vue&type=script&lang=js&"
export * from "./blank_only_logo.vue?vue&type=script&lang=js&"
import style0 from "./blank_only_logo.vue?vue&type=style&index=0&id=aeb416f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb416f2",
  null
  
)

export default component.exports